import React, { useEffect, useState } from "react";
import { setPageMeta } from "../seo/setPageMeta";

export default function Contact() {
  const API_URL = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [status, setStatus] = useState({
    loading: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    setPageMeta({
      title: "Contact Celebrate Recovery | Independence KY",
      description:
        "Contact Celebrate Recovery in Independence, Kentucky. Reach out with questions before your visit and someone from the ministry will get back to you.",
      canonical: "https://www.crindependenceky.com/contact",
    });
  }, []);

  function handleChange(event) {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();

    setStatus({
      loading: true,
      message: "",
      type: "",
    });

    try {
      const response = await fetch(`${API_URL}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to send message.");
      }

      setStatus({
        loading: false,
        message: "Your message has been sent successfully.",
        type: "success",
      });

      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      console.error("Contact form submission failed:", error);

      setStatus({
        loading: false,
        message: error.message || "There was a problem sending your message. Please try again.",
        type: "error",
      });
    }
  }

  return (
    <section>
      <h2 className="page-title">Contact Us</h2>
      <p className="page-intro">
        Have a question before you visit? Reach out and someone from the ministry
        will get back to you.
      </p>

      <div className="form-card">
        <form className="form-grid" onSubmit={handleSubmit}>
          <div className="form-grid two-col">
            <div>
              <label className="label" htmlFor="contact-name">Name</label>
              <input
                className="input"
                id="contact-name"
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div>
              <label className="label" htmlFor="contact-email">Email</label>
              <input
                className="input"
                id="contact-email"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div>
            <label className="label" htmlFor="contact-phone">Phone</label>
            <input
              className="input"
              id="contact-phone"
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

          <div>
            <label className="label" htmlFor="contact-message">Message</label>
            <textarea
              className="textarea"
              id="contact-message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>

          <button
            className="btn btn-primary"
            type="submit"
            disabled={status.loading}
          >
            {status.loading ? "Sending..." : "Send Message"}
          </button>
        </form>

        {status.message && (
          <p
            className={`status-message ${
              status.type === "success" ? "status-success" : "status-error"
            }`}
          >
            {status.message}
          </p>
        )}
      </div>
    </section>
  );
}